import { useLocation } from "react-router-dom"
import { useFlags } from "launchdarkly-react-client-sdk"

const SPECIALIST_SLUG = "specialist"

export const useShowSpecialistSchedulePage = (): boolean => {
  const { pathname } = useLocation()
  const isSpecialistFlow = pathname.includes(SPECIALIST_SLUG)
  const { showTtcMedicalSpecialistsPage } = useFlags()

  return isSpecialistFlow && showTtcMedicalSpecialistsPage
}
